module.exports = __webpack_public_path__ + "static/hero-download-lg-4e6ca30be0af03aed394e1bead5bac47.jpg";